import { RouterModule } from '@angular/router';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedServices } from './services/index'
import { SharedPipes } from './pipes/index'
import { SharedComponents } from './components/index'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslationModuleForChild } from '@examsoft/translation'


const sharedHelpers = [];

@NgModule({
  declarations: [
    ...SharedComponents,
    ...SharedPipes
  ],
  imports: [
    RouterModule,
    BrowserAnimationsModule,
    CommonModule,
    TranslationModuleForChild,
    
  ],
  exports: [
    ...SharedComponents,
    ...SharedPipes,
    
  ],
  providers: [
    ...SharedServices,
    ...sharedHelpers
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})

export class SharedModule {}
